/* Bonst cart – «Bytt til månedlig levering» (26.10).
   For hver engangsvare i handlekurven som også finnes som abonnement, vises et valg under varen.
   Ett trykk bytter linjen til abonnementet (samme selling plan som på produktsiden, /cart/change.js).
   Varer fra samme «Bygg din bundle»-boks (_bonst_box) byttes samlet. Gratisvarer/gaver hoppes over. */
(function () {
  if (window.__bonstCartSub) return;
  window.__bonstCartSub = true;

  var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var productCache = {};
  var busy = false;

  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    return (v[1] === '00' ? v[0] : v[0] + ',' + v[1]) + ' kr';
  }

  function product(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  // plan + subscription price for one line, or null
  function planFor(item) {
    if (item.selling_plan_allocation || item.final_line_price <= 0) return Promise.resolve(null);
    var props = item.properties || {};
    if (props._appstle_bundle_combo_id || props._bonst_gave) return Promise.resolve(null);
    return product(item.handle).then(function (p) {
      if (!p || !p.selling_plan_groups || !p.selling_plan_groups.length) return null;
      var plan = p.selling_plan_groups[0].selling_plans[0];
      if (!plan) return null;
      var v = (p.variants || []).find(function (x) { return x.id === item.variant_id; });
      var alloc = v && (v.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id === plan.id; });
      if (!alloc) return null;
      var adj = plan.price_adjustments && plan.price_adjustments[0];
      var pct = adj && adj.value_type === 'percentage' ? adj.value : Math.round((1 - alloc.price / v.price) * 100);
      return { plan: plan.id, pct: pct, unitSub: alloc.price, unitOnce: v.price };
    });
  }

  function render() {
    if (busy) return;
    var rows = document.querySelectorAll('cart-items .cart-item');
    if (!rows.length) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return Promise.all(cart.items.map(planFor)).then(function (plans) {
          document.querySelectorAll('.bonst-csub-row, .bonst-csub').forEach(function (el) { el.remove(); });
          var groups = [];
          var byBox = {};
          cart.items.forEach(function (item, i) {
            if (!plans[i]) return;
            var box = item.properties && item.properties._bonst_box;
            var entry = { index: i + 1, item: item, plan: plans[i] };
            if (box) {
              if (!byBox[box]) { byBox[box] = { box: true, lines: [] }; groups.push(byBox[box]); }
              byBox[box].lines.push(entry);
            } else {
              groups.push({ box: false, lines: [entry] });
            }
          });
          groups.forEach(function (g) {
            var last = g.lines[g.lines.length - 1];
            var row = document.getElementById('CartItem-' + last.index);
            var cell = row && row.querySelector('.cart-item__details');
            if (!cell) return;
            var pct = g.lines[0].plan.pct;
            var save = g.lines.reduce(function (s, l) { return s + Math.round(l.item.final_line_price * l.plan.pct / 100); }, 0);
            var el = document.createElement('div');
            el.className = 'bonst-csub';
            el.innerHTML =
              '<span class="bonst-csub__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 11a8 8 0 0 0-14.3-4.9L4 8"/><path d="M4 3v5h5"/><path d="M4 13a8 8 0 0 0 14.3 4.9L20 16"/><path d="M20 21v-5h-5"/></svg></span>' +
              '<span class="bonst-csub__text"><b></b><small></small></span>' +
              '<button type="button" class="bonst-csub__btn">Bytt</button>';
            el.querySelector('b').textContent = (g.box ? 'Gjør boksen til månedlig levering' : 'Bytt til månedlig levering') + ' – spar ' + pct + ' %';
            el.querySelector('small').textContent = (save > 0 ? 'Du sparer ' + money(save) + ' · ' : '') + 'Aldri gå tom · Ingen binding';
            el.querySelector('button').setAttribute('aria-label', (g.box ? 'Gjør boksen' : 'Bytt ' + last.item.product_title) + ' til månedlig abonnement');
            el.querySelector('button').addEventListener('click', function () { switchLines(g.lines, el); });
            // mobil (Dawn viser raden som grid): full bredde under varen; desktop: egen tabellrad under varen, på linje med navnet
            if (getComputedStyle(row).display === 'grid') {
              row.appendChild(el);
            } else {
              var tr = document.createElement('tr');
              tr.className = 'bonst-csub-row';
              var td = document.createElement('td');
              td.colSpan = 10;
              td.style.paddingLeft = Math.max(0, cell.getBoundingClientRect().left - row.getBoundingClientRect().left) + 'px';
              td.appendChild(el);
              tr.appendChild(td);
              row.parentNode.insertBefore(tr, row.nextSibling);
            }
          });
        });
      })
      .catch(function () {});
  }

  function switchLines(lines, el) {
    if (busy) return;
    busy = true;
    el.classList.add('is-loading');
    el.querySelector('button').textContent = 'Bytter …';
    var chain = Promise.resolve();
    lines.forEach(function (l) {
      chain = chain.then(function () {
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: H,
          body: JSON.stringify({ id: l.item.key, quantity: l.item.quantity, selling_plan: l.plan.plan })
        }).then(function (r) { if (!r.ok) throw new Error('change'); });
      });
    });
    chain
      .then(function () { window.location.reload(); })
      .catch(function () {
        busy = false;
        el.classList.remove('is-loading');
        el.querySelector('button').textContent = 'Prøv igjen';
      });
  }

  var t = null;
  function later() { clearTimeout(t); t = setTimeout(render, 250); }

  function init() {
    render();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, later);
    var w = window.innerWidth;
    window.addEventListener('resize', function () { if (Math.abs(window.innerWidth - w) > 50) { w = window.innerWidth; later(); } });
    var ci = document.querySelector('cart-items');
    if (ci && 'MutationObserver' in window) {
      new MutationObserver(function (muts) {
        // re-add after Dawn re-renders the item list (ignore our own inserts)
        if (muts.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !(n.classList && (n.classList.contains('bonst-csub') || n.classList.contains('bonst-csub-row'))); }); })) later();
      }).observe(ci, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
